import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ModulesFacade } from '@library/store/modules/modules.facade';

/**
 * Pre-fetches data before accessing the route if data has not been loaded
 */
@Injectable({
  providedIn: 'root',
})
export class ModuleSelectResolver implements Resolve<void> {
  private readonly modulesFacade = inject(ModulesFacade);

  resolve(route: ActivatedRouteSnapshot): void {
    this.modulesFacade.selectModule(route.params.module_id);
  }
}
